import React from "react";
import PropTypes from 'prop-types';

import Base from "../Base";
import withInput from "../../../hoc/withInput";

import './style.scss';

class TitleInput extends Base {
	render() {
		const { id, title, desc } = this.props;
		return(
			<div className="ok-title-input-wrap">
				<div className="ok-title-input">{ title }</div>
				{
					desc &&
					<p>{desc}</p>
				}
			</div>
		);
	}
}


TitleInput.propTypes = {
	id: PropTypes.string,
};

export default withInput( TitleInput );
